import { jsx as r } from "react/jsx-runtime";
import { createContext as e, useMemo as o } from "react";
import { useFeatureFlagLocalOverrides as t } from "./hooks/useFeatureFlagLocalOverrides.js";
const i = e({}), s = ({ children: e2, defaultFlags: s2 }) => {
  const { overrides: a } = t(), c = o(() => ({ ...s2, ...a }), [s2, a]);
  return r(i.Provider, { value: c, children: e2 });
};
export {
  i as FeatureFlagContext,
  s as FeatureFlagProvider
};
//# sourceMappingURL=FeatureFlagProvider.js.map
